export enum HcpSwitchoverBlockerReason {
    NoMobile = 0,
    InvalidMobile = 1,
    SharedMobile = 2,
    SmsBlocked = 3,
    DefaultPassword = 4,
}

export interface IHcpSwitchoverBlocker {
    reason: HcpSwitchoverBlockerReason;
    sharedWith?: string | null;
}

export interface IHcpSwitchoverBlocked {
    healthcareProfessionalID: number;
    name: string;
    email: string;
    blockers: IHcpSwitchoverBlocker[];
}

export interface IHcpSwitchoverLegacyHcp {
    healthcareProfessionalID: number;
    name: string;
    email: string;
    excluded: boolean;
    blockers: IHcpSwitchoverBlocker[];
}

export interface IHcpSwitchoverCandidate {
    healthcareProfessionalID: number;
    name: string;
    email: string;
}

export interface IHcpSwitchoverBatch {
    batchSize: number;
}
